import React, { useMemo } from 'react';
import _get from 'lodash/get';
import _size from 'lodash/size';
import _isEmpty from 'lodash/isEmpty';
import styles from './index.module.scss';

import { EcommPlatform, UiKit } from 'components';
import { selectHelpers } from 'utils/uiKitHelpers';

export default function RetailerStoreSelection({
  list = [],
  value = null,
  error = null,
  isDisabled = false,
  onChange = () => {}
}) {
  const [isFocused, setIsFocused] = React.useState(false);

  const { optionsMap } = useMemo(() => {
    const stores = selectHelpers.createAllOptions(list);
    return selectHelpers.createOptions(stores);
  }, [list]);

  const selectedStore = _get(optionsMap, value, null);

  const accountsCount = _size(list);
  const firstAccountStoresCount = _size(_get(list, '[0].options', []));
  const hasOnlyOneStore = accountsCount === 1 && firstAccountStoresCount === 1;

  if (_isEmpty(list) || hasOnlyOneStore) {
    return null;
  }

  return (
    <UiKit.Select
      placeholder="Select your store"
      options={list}
      value={selectedStore}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      onChange={option => onChange(_get(option, 'value', null))}
      error={error}
      isDisabled={isDisabled}
      isSearchable={isFocused}
      formatOptionLabel={({ label, ecommerce_platform }) => (
        <div className={styles.content}>
          <EcommPlatform.Icon
            source={ecommerce_platform}
            className={styles.eCommerceIcon}
          />
          <span>{label}</span>
        </div>
      )}
      noOptionsMessage={() => 'Choose the store to login'}
    />
  );
}
